import React, { useEffect, useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import PulseLoader from "react-spinners/PulseLoader";

import api from "services/api";

import { Card } from "@mui/material";
import Grid from "@mui/material/Grid";

import { Empty } from "antd";

import Tooltip from "@mui/material/Tooltip";
import Pagination from "@mui/material/Pagination";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import { budgetOptions, MANUFACTURER_SERVICES } from "utils/data";
import SuiBadge from "components/SuiBadge";
import SuiTypography from "components/SuiTypography";
import SuiBadgeDot from "components/SuiBadgeDot";
import SuiBox from "components/SuiBox";
import SuiAvatar from "components/SuiAvatar";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import Switch from "@mui/material/Switch";
import Checkbox from "@mui/material/Checkbox";

import FormControlLabel from "@mui/material/FormControlLabel";

import { capitalCase } from "capital-case";
import { AccountContext } from "context/account";
import CounterContext from "context/counter";
import Prompt from "components/UpStyled/Prompt";
import toast from "react-hot-toast";
import moment from "moment";
import qs from "query-string";
import { useForm, Controller } from "react-hook-form";

import { filterParser, sortParser } from "utils/helper";
import { projectRequestsSortOptions } from "utils/data";

import ProjectDetail from "pages/ma/project/detail";
import ProjectCard3 from "components/UpStyled/project-card/ProjectCard3";

import MyProjectsContext from "context/my-projects";
import WorkingProjectList from "pages/ma/project/my-projects/components/WorkingProjectList";
import SavedProjectList from "pages/ma/project/my-projects/components/SavedProjectList";

const requestScopeOptions = [
  { label: "All Requests", value: "all" },
  { label: "Public Requests", value: "public" },
  { label: "My Requests", value: "private" },
];

const MARequestList = ({ type = "public-requests" }) => {
  const [data, setData] = useState({ hits: [], nbHits: 0, estimatedTotalHits: 0 });
  const [detail, setDetail] = useState([]);
  const user = useContext(AccountContext);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [searchStr, setSearchStr] = useState("");
  const [filterObj, setFilterObj] = useState({});
  const [readStatus, setReadStatus] = useState({});
  const [pageLoading, setPageLoading] = useState(false);
  const [isShowAllRequests, setIsShowAllRequests] = useState(false);

  const {
    stagesProjects,
    prospects,
    addMyFavoriteProject,
    removeMyFavoriteProject,
    addUnFavoriteProject,
    handleRefresh,
  } = useContext(MyProjectsContext);

  let location = useLocation();
  const url = location.href ? location.href : location.pathname + location.search;
  const urlObj = qs.parseUrl(url);
  const projectId = urlObj?.query?.id;

  const { setUnreadRequestCount } = useContext(CounterContext);

  const {
    register,
    handleSubmit,
    trigger,
    setValue,
    watch,
    getValues,
    reset,
    formState: { errors },
    control,
  } = useForm();

  useEffect(() => {
    if (!projectId) {
      reset({
        sort_by: projectRequestsSortOptions[0],
        service_required: null,
        budget: null,
        q: "",
        request_scope: requestScopeOptions[0],
      });
    }
  }, [projectId, url]);

  useEffect(() => {
    if (projectId) {
      retrieveProjectDetail(projectId);
    }
  }, [projectId, url]);

  useEffect(() => {
    if (user.id) {
      if (type != "public-requests" && type != "my-requests") {
        return;
      }
      const offset = pageSize * (page - 1);
      const limit = pageSize;
      let filter = { status: "requested" };
      // if (type == "my-requests") {
      //   filter["audiences"] = user.id;
      // } else if (type == "public-requests") {
      //   filter["audiences"] = { neq: user.id };
      // }
      filter["users_unfavor"] = {};
      filter["users_unfavor"]["neq"] = user.id;
      //hide all favor projects, all favorites will displayed in Saved-projects
      filter["users_favorites"] = {};
      filter["users_favorites"]["neq"] = user.id;

      retrieveProjects(offset, limit, "", filter);
      retrieveprojectReadStatus(user.id);
    }
  }, [user.id, type, projectId, url]);

  const retrieveProjects = async (offset = 0, limit = pageSize, q = "", filter = {}) => {
    const payload = { offset, limit };
    if (q) {
      payload["q"] = q;
    }
    let myFilter = { status: "requested" };

    if (Object.keys(filter).length > 0) {
      myFilter = { ...myFilter, ...filter };
    }

    //get sorting options from form values
    const sortOpt = getValues("sort_by");
    let sortStr = "";
    if (sortOpt && sortOpt.value) {
      sortStr = sortParser(sortOpt.value);
    }
    // if (type == "my-requests") {
    //   myFilter = {
    //     ...myFilter,
    //     audiences: user.id,
    //   };
    // } else if (type == "public-requests") {
    //   myFilter = {
    //     ...myFilter,
    //     audiences: { neq: user.id },
    //   };
    // }

    const newFilterStr = filterParser(myFilter);
    if (newFilterStr) {
      payload["filter"] = newFilterStr;
      setFilterObj(myFilter);
    }
    if (sortStr) {
      payload["sort"] = [sortStr];
    }
    try {
      //const { data } = await api.project.list({ owner_id: user.id });

      const { data } = await api.project.search(payload);

      setData(data ? data : { hits: [], nbHits: 0 });
    } catch (err) {
      console.log(err);
    }
  };

  const retrieveProjectDetail = async (id) => {
    try {
      setPageLoading(true);
      const { data } = await api.project.get(urlObj?.query?.id);
      const project = data["project"] ? data["project"] : {};
      setDetail(project);
      setPageLoading(false);
    } catch (err) {
      console.log(err);
      setPageLoading(false);
    }
  };

  const retrieveprojectReadStatus = async (user_id) => {
    try {
      const params = {
        resource_type: "prospect",
        user_id: user_id,
      };
      const { data } = await api.event.list(params);
      const user_view = data?.user_view || [];
      let readStatusMap = {};
      for (let i = 0; i < user_view.length; i++) {
        if (user_view[i]?.resource_id && user_view[i]?.action == "viewed") {
          const p_id = user_view[i].resource_id;
          readStatusMap[p_id] = true; //read
        }
      }
      setReadStatus(readStatusMap);
    } catch (err) {
      console.log(err);
    }
  };

  const handleApply = () => {
    const data = getValues();
    const offset = pageSize * (page - 1);
    const limit = pageSize;
    setSearchStr(data["keywords"]);
    let myFilter = {};
    //budget filter
    if (data["budget"] && data["budget"].value) {
      const budgetRange = data["budget"].value.split("~");
      const budget_min = budgetRange.length > 0 ? budgetRange[0] : "0";
      const budget_max = budgetRange.length > 1 ? budgetRange[1] : undefined;

      if (budget_max) {
        myFilter["budget_max"] = { eq: budget_max };
      }
      if (budget_min) {
        myFilter["budget_min"] = { eq: budget_min };
      }
    }
    //scope filter
    if (data["request_scope"]?.value == "private") {
      myFilter["audiences"] = user.id;
    } else if (data["request_scope"]?.value == "public") {
      myFilter["audiences"] = {};
      myFilter["audiences"]["neq"] = user.id;
    } else {
      delete myFilter["audiences"];
      //won't add filter, show all request
    }
    //unfavor filter
    if (isShowAllRequests) {
      delete myFilter["users_unfavor"];
    } else {
      myFilter["users_unfavor"] = {};
      myFilter["users_unfavor"]["neq"] = user.id;
    }
    //hide all favor projects, all favorites will displayed in Saved-projects
    myFilter["users_favorites"] = {};
    myFilter["users_favorites"]["neq"] = user.id;

    //service filter
    let services_required = [];
    if (data["service_required"]) {
      services_required = data["service_required"]?.value
        ? [data["service_required"]?.value]
        : data["service_required"].map((x) => x.value);
      if (services_required && services_required.length > 0) {
        myFilter["services_required"] = services_required;
      }
    }
    retrieveProjects(offset, limit, data["keywords"], myFilter);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    const offset = pageSize * (newPage - 1);
    const limit = pageSize;
    retrieveProjects(offset, limit, searchStr, filterObj);
  };

  const handleChangeRowsPerPage = (option) => {
    const newPageSize = parseInt(option.value, 10);
    setPageSize(newPageSize);
    setPage(1);
    const offset = 0;
    const limit = newPageSize;
    retrieveProjects(offset, limit, searchStr, filterObj);
  };

  const totalNumber = data.nbHits ? data.nbHits : data.estimatedTotalHits;
  const pageCount = parseInt(Math.ceil(totalNumber / pageSize), 10);
  const pageOptions = [];
  for (let i = 0; i < pageCount; i++) {
    pageOptions.push(i);
  }
  const entriesStart = pageSize * (page - 1) + 1;
  const entriesEnd = pageSize * page > totalNumber ? totalNumber : pageSize * page;

  const servicesOption = MANUFACTURER_SERVICES.map((x) => ({ label: x.label, value: x.value }));
  const handleOnView = (id) => {
    let temp = {};
    temp[id] = true;
    const newReadStatus = { ...readStatus, ...temp };
    let isAllRead = true;
    for (let x in newReadStatus) {
      if (!newReadStatus[x]) {
        isAllRead = false;
      }
    }
    if (isAllRead) {
      setUnreadRequestCount(0);
    }

    setReadStatus(newReadStatus);
  };

  const handleAddSavedInterests = async (project) => {
    try {
      await addMyFavoriteProject(user.id, user.account_type, project.id);
      let newData = data?.hits.filter((p) => p.id != project.id);

      setData({ hits: newData, estimatedTotalHits: data?.estimatedTotalHits - 1 });
      toast.success(`Add to my Saved Projects successfully!`);
    } catch (err) {
      toast.error(`Could not add to my Saved Projects!`);
    }
  };

  const handleClearFilter = () => {
    reset({
      budget: null,
      service_required: null,
      sort_by: projectRequestsSortOptions[0],
      q: "",
    });
    handleApply();
  };

  const handleShowAllRequests = (e, v) => {
    let myFilter = {
      ...filterObj,
    };

    if (v) {
      delete myFilter["users_unfavor"];
    } else {
      myFilter["users_unfavor"] = {};
      myFilter["users_unfavor"]["neq"] = user.id;
    }
    setIsShowAllRequests(v);
    const offset = pageSize * (page - 1);
    const limit = pageSize;
    retrieveProjects(offset, limit, searchStr, myFilter);
  };

  const handleNotInterested = (project) => {
    try {
      addUnFavoriteProject(user.id, user.account_type, project.id);

      let newData = data?.hits.filter((p) => p.id != project.id);

      setData({ hits: newData, estimatedTotalHits: data?.estimatedTotalHits - 1 });

      toast.success(`Remove from the list successfully!`);
    } catch (err) {
      console.log(err);
      toast.error(`Could not remove from the list!`);
    }
  };

  return projectId ? (
    <ProjectDetail project={detail} editable={false} pageLoading={pageLoading} />
  ) : (
    <Card sx={{ p: 3 }} key={type}>
      <div>
        <SuiBox pb={3}>
          <SuiBox component="form" onSubmit={handleSubmit(handleApply)}>
            <SuiBox
              display="flex"
              alignItems="flex-start"
              justifyContent="space-between"
              sx={{ width: "100%" }}
            >
              <SuiBox display="flex" alignItems="center" sx={{ gap: 1, flexWrap: "wrap" }}>
                <SuiTypography variant="button" color="dark" fontWeight="regular">
                  Filter by:
                </SuiTypography>
                <div style={{ maxWidth: 150 }}>
                  <Controller
                    name="request_scope"
                    control={control}
                    render={({ field }) => (
                      <SuiSelect
                        {...field}
                        options={requestScopeOptions}
                        placeholder="Requests"
                        backspaceRemovesValue
                      />
                    )}
                  />
                </div>
                <div style={{ maxWidth: 150 }}>
                  <Controller
                    name="service_required"
                    control={control}
                    render={({ field }) => (
                      <SuiSelect
                        {...field}
                        options={servicesOption}
                        placeholder="Service Needed"
                        backspaceRemovesValue
                      />
                    )}
                  />
                </div>
                <div style={{ width: 160 }}>
                  <Controller
                    name="budget"
                    control={control}
                    render={({ field }) => (
                      <SuiSelect
                        {...field}
                        options={budgetOptions}
                        placeholder="Budget"
                        backspaceRemovesValue
                      />
                    )}
                  />
                </div>
                <div style={{ width: 145 }}>
                  <Controller
                    name="sort_by"
                    control={control}
                    render={({ field }) => (
                      <SuiSelect
                        {...field}
                        options={projectRequestsSortOptions}
                        placeholder="Sort By"
                        backspaceRemovesValue
                      />
                    )}
                  />
                </div>
                <SuiBox>
                  <SuiInput placeholder="Keywords" type="text" {...register("keywords")} />
                </SuiBox>
                <div>
                  <SuiButton variant="gradient" color="dark" type="submit">
                    Apply
                  </SuiButton>
                </div>
                <SuiButton variant="gradient" color="secondary" onClick={handleClearFilter}>
                  Clear
                </SuiButton>
              </SuiBox>
            </SuiBox>
          </SuiBox>
          <SuiBox mt={1} display="flex" gap={1}>
            <SuiBox ml={1}>
              <Switch color="primary" value={isShowAllRequests} onChange={handleShowAllRequests} />

              <SuiTypography component="span" sx={{ ml: 2 }}>
                Show Not interested
              </SuiTypography>
            </SuiBox>
          </SuiBox>
        </SuiBox>
        {data?.hits && data.hits.length > 0 ? (
          data.hits.map((u, index) => (
            <ProjectCard3
              project={u}
              detailUrl={`/job/requests?id=${u.id}`}
              key={index}
              onView={() => handleOnView(u.id)}
              isRead={readStatus[u.id]}
              addProspect={() => handleAddSavedInterests(u)}
              removeProspect={() => handleNotInterested(u)}
            />
          ))
        ) : (
          <Empty />
        )}
        <SuiBox
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          p={3}
        >
          <div className="flex items-center">
            <SuiBox mb={{ xs: 3, sm: 0 }}>
              <SuiTypography variant="button" color="secondary" fontWeight="regular">
                Showing {entriesStart} to {entriesEnd} of {totalNumber} entries
              </SuiTypography>
            </SuiBox>

            <SuiBox display="flex" alignItems="center" gap={1}>
              <SuiSelect
                defaultValue={{ value: pageSize, label: pageSize }}
                options={[10, 20, 50].map((entry) => ({ value: entry, label: entry }))}
                onChange={handleChangeRowsPerPage}
                size="small"
              />

              <SuiTypography variant="caption" color="secondary">
                entries per page
              </SuiTypography>
            </SuiBox>
          </div>
          <Pagination
            variant={"outlined"}
            color={"info"}
            count={pageOptions.length}
            defaultPage={page}
            onChange={handleChangePage}
          />
        </SuiBox>
      </div>
    </Card>
  );
};

export default MARequestList;
